import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import NonBillableConceptsModalBasicForm from '@/modules/configurationModule/detail/automation/non-billable-concepts/components/non-billable-concepts-modal-basic-form/non-billable-concepts-modal-basic-form.vue'
import NonBillableConceptsModalAssociations from '@/modules/configurationModule/detail/automation/non-billable-concepts/components/non-billable-concepts-modal-associations/non-billable-concepts-modal-associations.vue'

@Component({
    components: {
        NonBillableConceptsModalBasicForm,
        NonBillableConceptsModalAssociations
    }
})
export default class NonBillableConceptsModal extends Vue {
    @Ref() readonly nonBillableConceptsModal!: any

    @Prop(String) readonly actionTitle!: string

    show() {
        this.nonBillableConceptsModal.show()
    }

    hide() {
        this.nonBillableConceptsModal.hide()
    }
}
